import React, { Component } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default class Credits extends Component {
  render() {
    return (
      <div>
        <Header />

        <div
          className="hero has-text-centered"
          style={{ marginTop: "150px", marginBottom: "200px" }}
        >
          <p>
            This app wouldn't be possible without these open-source packages:
          </p>
          <br />
          <ul>
            <li>react</li>
            <li>create-react-app</li>
            <li>react-feather</li>
            <li>react-helmet</li>
            <li>react-router-dom</li>
            <li>moment</li>
            <li>spacex-api</li>
          </ul>
        </div>

        <Footer />
      </div>
    );
  }
}
